/**
 * Created by mbiao on 2017/8/23.
 */
import './common/js/polyfill';
import '@admin/fe2app-sdk';
import Vue from 'vue';
import VueResource from 'vue-resource';
import VueRouter from 'vue-router';
import routes from './router/index.js'; // 路由配置文件
import store from './vuex/index';
import { commonFn } from './common/js/common.js';
import { apiPath } from './common/js/config.js';
import platform from './common/js/platform';
import App from './app.vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueClipboard from 'vue-clipboard2';
// require styles
import 'swiper/dist/css/swiper.css';
import './common/js/senseSdk.js'; // 大数据sdk埋点
import {
	Image,
	Picker,
	Popup,
	Area,
	Tab,
	Tabs,
	Loading,
	Switch,
	SwipeCell,
	Button,
	ActionSheet,
	PullRefresh,
	Toast,
	Swipe,
	SwipeItem,
	List,
	Circle,
	Popover,
	Field,
	Icon,
	Rate
} from 'vant';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/zh-cn';
import { judgeAndTransformUcToken } from './common/js/ucToken';
import Contextmenu from "vue-contextmenujs"

Vue.use(Contextmenu);

dayjs.locale('zh-cn');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Shanghai');


Vue.use(Rate);
Vue.use(Icon);
Vue.use(Image);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Area);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Loading);
Vue.use(Switch);
Vue.use(SwipeCell);
Vue.use(Button);
Vue.use(ActionSheet);
Vue.use(PullRefresh);
Vue.use(Toast);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(List);
Vue.use(Circle);
Vue.use(Popover);
Vue.use(Field);
Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(VueAwesomeSwiper /* { default global options } */);
Vue.use(VueClipboard);
Vue.config.debug = process.env.NODE_ENV !== 'production';
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.http.options.emulateJSON = true;

const router = new VueRouter(routes);

if (!commonFn.parseUA().wxMiniprogram && !commonFn.isH5()) {
	Vue.http.headers.common['system'] = 'app_web';
}

router.beforeEach((to, from, next) => {
	let { hide_sys } = to.query;
	console.log(hide_sys, 'hide_sys', to);
	if (hide_sys || commonFn.isYdk()) {
		setTimeout(() => {
			commonFn.hideFooter();
			store.commit('setHideSignTips', true);
		}, 100);
	}

	// 投放域名页面修改
	try {
		const isRelease =
			to.query.from == 'taluo' || sessionStorage.getItem('isShowTaluoPop') === '0' || '';
		if (isRelease) {
			document
				.querySelector('meta[name="keywords"]')
				.setAttribute(
					'content',
					'知屿，情感，咨询，问答，语音，在线咨询，婚姻修复，恋爱挽回，感情，婚姻，事业，财富，住宅，李静唯，陈鹏，任东生，苏法光，苏敬，李明骏，左西西，张星亮，姜联伟，九鼎老师，冠元'
				);
			document
				.querySelector('meta[name="description"]')
				.setAttribute(
					'content',
					'专业语音问答咨询频道！专业的老师解决您的生活疑问，指导您的人生，亲自解答婚姻感情，事业财富问题'
				);
		}
	} catch (error) {
		console.log(error);
	}
	next();
});

router.afterEach(() => {
	// 解决route库版本使用history api的路由无法监听到popstate事件（大数据SDK）
	const event = new Event('hashchange');
	window.dispatchEvent(event);
});

let app = null;
// 获取本地存储的灵机用户信息
let localLingHitUserId = localStorage.getItem('lingHitUserId');
// 获取本地存储的易起问用户token
let yiQiWenToken =
	commonFn.getParams()['token'] ||
	localStorage.getItem('yiQiWenToken') ||
	commonFn.getCookieItem('_token') ||
	'';
if (commonFn.parseUA().wxMiniprogram) {
	const open_id = commonFn.getParams()['open_id'];
	localStorage.setItem('open_id', open_id);
}

// 获取当前的平台
let userInfo = {};
// 调登灵机内嵌登录接口
const login = async () => {
	let tipEle = document.getElementById('tip-box');
	tipEle.style.display = 'block';
	userInfo.platform = platform;
	localStorage.setItem('platform', userInfo.platform);
	app.$store.commit('setPlatform', userInfo.platform);

	await Vue.http
		.post(apiPath.login, userInfo, { emulateJSON: true })
		.then((res) => {
			if (res.body.code == 1 && res.body.data.token) {
				tipEle.style.display = 'none';
				// 获得token，把token存到本地
				Vue.http.headers.common['Authorization'] = res.body.data.token;
				Vue.http.headers.common['YQW-Token'] = res.body.data.token;
				app.$store.commit('setUserIsLogin', true);
				app.$store.dispatch('getIsNewUserAndHasCoupon');
				try {
					localStorage.setItem('yiQiWenToken', res.body.data.token);
					commonFn.setCookieItem(
						'_token',
						res.body.data.token,
						Infinity,
						'/',
						'yiqiwen.cn'
					);
					localStorage.setItem('lingHitUserId', userInfo.userid);
					// // 已登录用户绑定大数据userid
					// commonFn.linkUseridToSense(userInfo.userid);
				} catch (e) { }
				app.$mount('#app');
				// 5秒后清除login_times，保证下次可以登录
				setTimeout(() => {
					sessionStorage.removeItem('login_times');
				}, 5000);
			} else {
				document.getElementsByClassName('login-loading')[0].textContent =
					res.body.msg + ',请登录后重试';
				sessionStorage.removeItem('login_times');
				localStorage.removeItem('yiQiWenToken');
				commonFn.removeCookieItem('_token', '/', 'yiqiwen.cn');
			}
		})
		.catch((e) => {
			tipEle.style.display = 'none';
			sessionStorage.removeItem('login_times');
			localStorage.removeItem('yiQiWenToken');
			commonFn.removeCookieItem('_token', '/', 'yiqiwen.cn');
		});
};
/*
 * @method 判断是否需要登录方法
 * @desc 判断当前用户是否包含登录信息，然后调不同的登录方式
 * */
const isGoToLogin = () => {
	try {
		userInfo = window.mmc.user.getInfo() || {};
	} catch (e) {
		console.error(e);
	}
	// 易起问APP，可以直接拿token
	if (userInfo.token && (window.mmc.client.is('ljds') || window.mmc.client.is('ydk'))) {
		Vue.http.headers.common['Authorization'] = userInfo.token;
		Vue.http.headers.common['YQW-Token'] = userInfo.token;
		localStorage.setItem('yiQiWenToken', userInfo.token);
		localStorage.setItem('platform', userInfo.platform);
		app.$store.commit('setUserIsLogin', true);
		app.$store.commit('setPlatform', userInfo.platform);
		app.$store.dispatch('getIsNewUserAndHasCoupon');
		// // 已登录用户绑定大数据userid
		// commonFn.linkUseridToSense(userInfo.userid);
		return app.$mount('#app');
	}

	if (userInfo.userid) {
		// 手机号判断"0"
		if (!parseInt(userInfo.mobilephone)) {
			let tipEle = document.getElementById('tip-box');
			tipEle.style.display = 'block';
			document.getElementsByClassName('login-loading')[0].textContent =
				'未绑定手机号，请绑定后重新打开';
			return undefined;
		}
		userInfo.channel = commonFn.getParams()['channel'] || localStorage.getItem('channel') || '';
		// 本地有没有灵机token
		if (localLingHitUserId && localLingHitUserId == userInfo.userid) {
			if (!yiQiWenToken) {
				login();
			} else {
				Vue.http.headers.common['Authorization'] = yiQiWenToken;
				Vue.http.headers.common['YQW-Token'] = yiQiWenToken;
				app.$store.commit('setUserIsLogin', true);
				app.$store.dispatch('getIsNewUserAndHasCoupon');
				// // 已登录用户绑定大数据userid
				// commonFn.linkUseridToSense(userInfo.userid);
				app.$mount('#app');
			}
		} else {
			login();
		}
	} else {
		app.$mount('#app');
	}
};

const init = async () => {
	// 去除链接参数上的token
	let paramsToken = commonFn.getParams()['token'];

	// 支持uc_token登录
	const paramsUcToken = commonFn.getParams()['uc_token'];
	const transformToken = await judgeAndTransformUcToken(yiQiWenToken);
	if (transformToken) {
		paramsToken = transformToken;
		yiQiWenToken = transformToken;
	}

	console.log(paramsToken, 'paramsToken');
	if (paramsToken || paramsUcToken) {
		paramsToken && localStorage.setItem('yiQiWenToken', paramsToken);
		let path = commonFn.delUrlParams(location.href, 'token');
		path = commonFn.delUrlParams(path, 'uc_token');
		location.replace(path);
		return;
	}
	try {
		await store.dispatch('getConfig');
	} catch (error) {
		console.log(error);
	}

	app = new Vue({
		router,
		store,
		template: '<App/>',
		components: { App }
	});

	if (commonFn.parseUA().wxMiniprogram) {
		//微信小程序
		// 初始化登陆状态
		if (yiQiWenToken) {
			/* 设置登录态 */
			Vue.http.headers.common['Authorization'] = yiQiWenToken;
			Vue.http.headers.common['YQW-Token'] = yiQiWenToken;
			app.$store.commit('setUserIsLogin', true);
			app.$store.dispatch('getIsNewUserAndHasCoupon');
		} else {
			app.$store.commit('setUserIsLogin', false);
		}
		// 非客户端做特殊处理
		app.$mount('#app');
		return;
	}

	if (!commonFn.isH5()) {
		window.mmc.init();
		setTimeout(() => {
			isGoToLogin();
		}, 100);
	} else {
		/* 必须登录才能 */
		Vue.http.headers.common['Authorization'] = yiQiWenToken;
		Vue.http.headers.common['YQW-Token'] = yiQiWenToken;

		// 初始化登陆状态
		if (yiQiWenToken) {
			app.$store.commit('setUserIsLogin', true);
			app.$store.dispatch('getIsNewUserAndHasCoupon');
		} else {
			app.$store.commit('setUserIsLogin', false);
		}
		// 非客户端做特殊处理
		app.$mount('#app');
	}


};

// 初始化vConsole
const initVConsole = async () => {
	function isSandbox() {
		let host = location.host;
		let search = location.search;
		return (
			/\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/.test(host) ||
			/localhost/i.test(host) ||
			/sandbox/i.test(host) ||
			/isShowVConsole=1/.test(search)
		);
	}
	if (!isSandbox()) {
		return;
	}

	const VConsole = await import(/* webpackChunkName: "vConsole" */ 'vconsole');
	window.vConsole = new VConsole();
};

// 执行初始化函数
(async () => {
	await initVConsole();
	init();

})();



// WEBPACK FOOTER //
// ./src/main.js